var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"metric-insights pa-0",attrs:{"fill-height":"","fluid":""}},[_c('page-title',{attrs:{"title":"Metric Insights"}}),_c('Tabs',{attrs:{"settings":_vm.tabSettings}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }